export const DM_INITIAL_STATE = { conversations: {}, currentKey: null, toast: null }

export function dmReducer(state, action) {
  switch (action.type) {
    case "OPEN": {
      const { target } = action
      const key = target.key
      const existing = state.conversations[key]
      return {
        ...state,
        currentKey: key,
        toast: state.toast?.key === key ? null : state.toast,
        conversations: {
          ...state.conversations,
          [key]: existing
            ? { ...existing, target, unread: 0, error: "", loading: false }
            : { target, messages: [], unread: 0, loading: false, loaded: false, sending: false, error: "" },
        },
      }
    }
    case "MINIMIZE":
      return { ...state, currentKey: null }
    case "CLOSE": {
      if (!state.currentKey) return state
      const next = { ...state.conversations }
      delete next[state.currentKey]
      return { ...state, currentKey: null, conversations: next, toast: null }
    }
    case "LOAD_START": {
      const cur = state.conversations[action.key]
      if (!cur) return state
      return {
        ...state,
        conversations: {
          ...state.conversations,
          [action.key]: {
            ...cur,
            loading: true,
            error: "",
          },
        },
      }
    }
    case "LOAD_SUCCESS": {
      const cur = state.conversations[action.key]
      if (!cur) return state
      return {
        ...state,
        conversations: {
          ...state.conversations,
          [action.key]: {
            ...cur,
            loading: false,
            loaded: true,
            error: "",
            messages: mergeDmMessageList(cur.messages, action.messages || []),
          },
        },
      }
    }
    case "LOAD_ERROR": {
      const cur = state.conversations[action.key]
      if (!cur) return state
      return {
        ...state,
        conversations: {
          ...state.conversations,
          [action.key]: {
            ...cur,
            loading: false,
            error: action.error || "",
          },
        },
      }
    }
    case "SEND_START": {
      const key = action.key || state.currentKey
      if (!key) return state
      const cur = state.conversations[key]
      if (!cur) return state
      return {
        ...state,
        conversations: {
          ...state.conversations,
          [key]: {
            ...cur,
            sending: true,
            error: "",
          },
        },
      }
    }
    case "SEND": {
      const key = action.key || state.currentKey
      if (!key) return state
      const cur = state.conversations[key]
      if (!cur) return state
      return {
        ...state,
        conversations: {
          ...state.conversations,
          [key]: {
            ...cur,
            messages: mergeDmMessageList(cur.messages, [ action.message ]),
            sending: false,
            error: "",
          },
        },
      }
    }
    case "SEND_ERROR": {
      const key = action.key || state.currentKey
      if (!key) return state
      const cur = state.conversations[key]
      if (!cur) return state
      return {
        ...state,
        conversations: {
          ...state.conversations,
          [key]: {
            ...cur,
            sending: false,
            error: action.error || "",
          },
        },
      }
    }
    case "RECEIVE": {
      const { key } = action
      const recv = state.conversations[key]
      const nextConversation = recv || {
        target: action.target,
        messages: [],
        unread: 0,
        loading: false,
        loaded: false,
        sending: false,
        error: "",
      }
      const isVisible = state.currentKey === key
      return {
        ...state,
        conversations: {
          ...state.conversations,
          [key]: {
            ...nextConversation,
            target: action.target || nextConversation.target,
            loaded: nextConversation.loaded,
            error: "",
            messages: mergeDmMessageList(nextConversation.messages, [ action.message ]),
            unread: isVisible ? 0 : (nextConversation.unread || 0) + 1,
          },
        },
        toast: isVisible
          ? state.toast
          : { id: Date.now(), key, target: action.target || nextConversation.target, text: action.message.text },
      }
    }
    case "DISMISS_TOAST":
      if (action.key && state.toast?.key !== action.key) return state
      return { ...state, toast: null }
    default:
      return state
  }
}

export function mergeDmMessageList(existing = [], incoming = []) {
  const merged = [ ...existing ]
  const seen = new Set(existing.map((message) => String(message.id)))

  incoming.forEach((message) => {
    const key = String(message.id)
    if (seen.has(key)) return
    seen.add(key)
    merged.push(message)
  })

  merged.sort((left, right) => {
    if (left.createdAt && right.createdAt) {
      return new Date(left.createdAt).getTime() - new Date(right.createdAt).getTime()
    }
    return String(left.id).localeCompare(String(right.id), undefined, { numeric: true })
  })

  return merged
}
